// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { TxnBatch } from './txn-batch';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TxnHeader extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  txnHeaderId!: number;
  bankId?: number;
  customerNumber?: string;
  descriptionOfTransactions?: string;
  fileCreatedDate?: Date;
  fileCreditAmount?: number;
  fileCreditTransactions?: number;
  fileDebitAmount?: number;
  fileDebitTransactions?: number;
  processingDate?: Date;
  txnBatches!: TxnBatch[];
}

